import { IQuickSortState } from "../../IQuickSortState";
import { QuickSortStep } from "../../enums/QuickSortStep"
import { IQuickSortContext } from "../../IQuickSortContext"
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { QuickSortEntryState } from "./QuickSortEntryState";
import { QuickSortCallEnvironment } from "../../stack/QuickSortCallEnvironment";

export class QuickSortRightRecursionCallState implements IQuickSortState {

  ThisQuickSortStep = QuickSortStep.QuickSortRightRecursionCall;
  
  Description = "(Right Recursion) Call QuickSort (push values to stack)";

  private _savedState : { 
    PushedObjects: Array<any> | undefined
   } | undefined;

  private _context : IQuickSortContext | undefined;
  
  SetContext(context: IQuickSortContext): void {
    this._context = context;
  } 
  
  Do(): void {
    
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._context.PartitionIndex);
    assertIsDefined(this._context.Hi);

    //
    // The return restored lo, hi and partitionIndex...
    // ideally one step would follow the return ... that is restoring stuff from stack...
    //

    let numbers: Array<number> = this._context.Numbers;
    let lo: number = this._context.PartitionIndex + 1;
    let hi: number = this._context.Hi;

    let callEnvironment : QuickSortCallEnvironment = {
      CallerStep: this.ThisQuickSortStep,
      CallerPartitionIndex: this._context.PartitionIndex,
      CallerHi: this._context.Hi,
      CallerLo: this._context.Lo
    }   

    if (this._savedState === undefined) {
      this._savedState = {
        PushedObjects: [numbers, lo, hi, callEnvironment]
      }
    }
    else {
      this._savedState.PushedObjects = [numbers, lo, hi, callEnvironment];
    }

    this._context.AlgoStack.push(callEnvironment);
    this._context.AlgoStack.push(hi);
    this._context.AlgoStack.push(lo);
    this._context.AlgoStack.push(numbers);
  }

  Undo(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Numbers);
    assertIsDefined(this._context.AlgoStack);
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.PushedObjects);

    this._context.AlgoStack.pop();
    this._context.AlgoStack.pop();
    this._context.AlgoStack.pop();
    this._context.AlgoStack.pop();
  }

  Exit(): void {
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.PushedObjects);

    console.log(`QS RIGHT RECURSION:`);
    console.log(`\tEnvPI: ${this._savedState.PushedObjects[3].CallerPartitionIndex}`);
    console.log(`\tEnvLO: ${this._savedState.PushedObjects[3].CallerLo}`);
    console.log(`\tEnvHI: ${this._savedState.PushedObjects[3].CallerHi}`);

    if (this._context) {
      this._context.TransitionTo(new QuickSortEntryState());
    }
  }
}